export const key = "6Lc7qs8ZAAAAAK9tlGsogO0nCvRnJglqP_mbhWeF";